export { PromiseQueue as default } from 'choerodon-ui/dataset';
